import {useMutation} from "@tanstack/react-query";
import {AccountSearchInterface} from "../../correspondent/list/interface/searchInterface";
import {exportPtaTierExcelApi} from "../../../../api/correspondent/tierApi";
import moment from "moment";
import {downloadFile} from "../../../../util/FileDownload";
import {useModal} from "../../../../hooks";
import {AxiosError} from "axios";

/**
 * pta 티어 엑셀 내보내기
 * @param props
 * @returns
 */
export const useExportPtaTierExcel = () => {
    const {handleModal} = useModal();

    const {mutate} = useMutation({
        mutationFn: (data: AccountSearchInterface) => exportPtaTierExcelApi(data),
        onSuccess: (res) => {
            if (res instanceof Blob) {
                downloadFile(
                    res,
                    `PTA_Tier_목록_${moment(new Date()).format("YYYY_MM_DD")}.xlsx`
                );
            }
        },
        onError: (error: AxiosError) => {
            console.log(error);
            if (error?.response?.data instanceof Blob) {
                error.response.data.text().then((value) => {
                    const obj = JSON.parse(value);
                    handleModal({
                        isOpen: true,
                        contents: obj?.msg,
                        type: "alert",
                    });
                });
            }
        },
    });

    return {mutate};
};
